export type UserRole = 'SUPER_ADMIN' | 'SALON_OWNER' | 'MANAGER' | 'STAFF';

export interface User {
	id: string;
	email: string;
	name: string;
	role: UserRole;
	businessName?: string;
	locationId?: string;
}

export interface AuthState {
	user: User | null;
	isAuthenticated: boolean;
	login: (email: string, password: string) => Promise<boolean>;
	logout: () => void;
	updateUser: (user: User) => void;
}

export interface LoginCredentials {
	email: string;
	password: string;
	rememberMe?: boolean;
}

// Mock credentials for development
export const MOCK_CREDENTIALS: Record<
	UserRole,
	{ email: string; password: string; user: User }
> = {
	SUPER_ADMIN: {
		email: 'admin@beautyportal.com',
		password: 'admin123',
		user: {
			id: '1',
			email: 'admin@beautyportal.com',
			name: 'Super Admin',
			role: 'SUPER_ADMIN',
		},
	},
	SALON_OWNER: {
		email: 'owner@beautyportal.com',
		password: 'owner123',
		user: {
			id: '2',
			email: 'owner@beautyportal.com',
			name: 'Salon Owner',
			role: 'SALON_OWNER',
			businessName: '200Below',
			locationId: 'minnesota',
		},
	},
	MANAGER: {
		email: 'manager@200below.com',
		password: 'manager123',
		user: {
			id: '3',
			email: 'manager@200below.com',
			name: 'Manager',
			role: 'MANAGER',
			businessName: '200Below',
		},
	},
	STAFF: {
		email: 'staff@beautyportal.com',
		password: 'staff123',
		user: {
			id: '4',
			email: 'staff@beautyportal.com',
			name: 'Maria Garcia',
			role: 'STAFF',
			businessName: '200Below',
		},
	},
};
